<lib-swipeable (swipeDown)="close.emit()">
  <div class="closable-bottom-sheet-handle">
    <div class="bottom-slide-in-top-dash"></div>
  </div>
</lib-swipeable>
